export const SEARCH_DELAY = 500; // ms
